export type RegisterState = {
  email: string;
  password: string;
  /**
   * Typed a second time, and compared before anything is sent.
   *
   * A mistyped password on registration locks a parent out of an account they have just created, and the
   * only route back is the reset — which needs the mailbox they may also have mistyped (R0066).
   */
  passwordConfirmation: string;
  displayName: string;
  isSubmitting: boolean;
  error: string | null;
};

export const passwordsMatch = (state: RegisterState): boolean =>
  state.password === state.passwordConfirmation;

export const canSubmit = (state: RegisterState): boolean =>
  !state.isSubmitting &&
  state.email.trim().length > 0 &&
  state.password.length > 0 &&
  state.passwordConfirmation.length > 0 &&
  passwordsMatch(state);
